require('trunks/vue/admin/core_ext/index.js');

import Elements from 'trunks/elements/admin/index.js';
Skylark.Elements = Elements;

import Bridge from 'trunks/vue/admin/bridge.js';
Skylark.Bridge = Bridge;

require('trunks/channels/index.js');
require('trunks/controllers/admin/index.js');

import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Bootloader from 'trunks/bootloader/admin.js'
Bootloader.start();
